import { z } from 'zod';
import { TenantIdSchema } from './_primitives.js';

// Amabile & Kramer (2011) Progress Principle — catalysts and nourishers taxonomy.
// Each entry type maps to a recognised progress event category.
export const PROGRESS_ENTRY_TYPES = Object.freeze({
  LOAD_DELIVERED:     'load_delivered',
  EXCEPTION_RESOLVED: 'exception_resolved',
  CUSTOMER_HELPED:    'customer_helped',
  SAVE_EXECUTED:      'save_executed',
  MENTORSHIP_GIVEN:   'mentorship_given',
  STREAK_MILESTONE:   'streak_milestone',
  USER_AUTHORED:      'user_authored',
});

export const ProgressEntryTypeEnum = z.enum(Object.values(PROGRESS_ENTRY_TYPES));

// Append-only. One collection, many entries per worker.
// Firestore writes: CF only (Admin SDK). Client reads: subject worker only.
// Hard-delete permitted on user request — GDPR/CCPA exception to soft-delete rule.
export const ProgressLedgerEntrySchema = z.object({
  entryId:          z.string().min(1),
  workerId:         z.string().min(1),
  tenantId:         TenantIdSchema,
  entryType:        ProgressEntryTypeEnum,
  contextRef:       z.string().nullable().optional(),
  // AEGIS-generated via Haiku, or user-written for user_authored entries.
  headline:         z.string().min(1).max(280),
  // AHI-3 Purpose Thread populates this field — null until then.
  downstreamImpact: z.string().nullable().optional(),
  capturedAt:       z.union([z.string(), z.object({}).passthrough()]),
  userAcknowledged: z.boolean(),
  // SDT autonomy principle (Deci & Ryan 2000): worker owns their own narrative.
  userHidden:       z.boolean(),
  aegisGenerated:   z.boolean().optional(),
  softDeleted:      z.boolean().optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof ProgressLedgerEntrySchema>} ProgressLedgerEntry */
